module.exports = __webpack_public_path__ + "img/award-content-ar.c22cd4d3.png";